import { BsAsterisk } from 'react-icons/bs'

const CamposObligatoriosLeyenda = () => {
    return <h6 className="mt-0 mb-3" style={{ fontSize: 15 }}>Los campos marcados con <BsAsterisk/> son obligatorios</h6>
}

export default CamposObligatoriosLeyenda